export const DT_KAKAO_CHANNEL_ID = '_nxewixj';
